import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingLowerImageSizeConfig } from '@/data/landingConfig/landingLowerImageSizeConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_LowerImageSize } from './schemaObject';

interface Props {}
const LowerImageSize: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_LowerImageSize} />
			<LandingTemplate
				data={landingLowerImageSizeConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default LowerImageSize;
